import styled from 'styled-components'

export const StyledEmoji = styled.img`
  line-height: 0;
  width: 16px;
  position: relative;
  top: 2px;
`
